import apiClient from '../../../api/apiConfig';
import { ServerStepGroup, WorkflowServerExpect } from '../ServerWorkflowType';

const BASE_URL = '/csb/workflows';

interface CreateWorkflowResponse {
  message?: string;
  success: boolean;
  workflowId?: number;
}

const cleanStepGroup = (
  stepGroup: ServerStepGroup | null | undefined
): ServerStepGroup | null => {
  if (!stepGroup) {
    return null;
  }

  return {
    ...stepGroup,
    nextStepGroup: cleanStepGroup(stepGroup.nextStepGroup),
    steps: stepGroup.steps?.map((step) => ({
      ...step,
      failbackStepGroup: cleanStepGroup(step.failbackStepGroup),
      nestedStepGroup: cleanStepGroup(step.nestedStepGroup),
      workflowStepGroupId: null,
      workflowStepId: null,
    })),
    workflowStepGroupId: null,
  };
};

const cleanWorkflowBeforePost = (
  workflow: WorkflowServerExpect
): WorkflowServerExpect => {
  return {
    ...workflow,
    failbackStepGroup: cleanStepGroup(workflow.failbackStepGroup),
    name: workflow.name?.trim() || null,
    nextStepGroup: cleanStepGroup(workflow.nextStepGroup),
  };
};

export const createWorkflow = async (
  workflow: WorkflowServerExpect
): Promise<CreateWorkflowResponse | Error> => {
  const cleanedWorkflow = cleanWorkflowBeforePost(workflow);
  const response = await apiClient.post<CreateWorkflowResponse>(
    `${BASE_URL}`,
    cleanedWorkflow
  );
  return response.data;
};
